
import { WDFormBasic } from './wd-form-basic';
import WDDropdownGroupedForm from '../dropdown/wd-dropdown-grouped-form';

export class WDFormDropdowngrouped extends WDFormBasic {

	#dropdown = null;
				
	constructor(opts)
	{
	  let dd = new WDDropdownGroupedForm(opts);;

		super(dd,opts);

		this.#dropdown = dd;

    this.bubbleEvents(this.#dropdown,['change','value:set','model:set','item:added','items:added']);
    this.#dropdown.on('model:set', (evt) => this.trigger('options:set', evt));

	};

	get options() { return this.#dropdown.options(); };
  set options(newOptions) { return this.#dropdown.options = newOptions; };
  	
  get value() { return this.#dropdown.value; };
  set value(val) { this.#dropdown.value = val; };

  set valueLabel(lbls) { this.#dropdown.valueLabel = lbls; };

  get readonly() { return this.#dropdown.readonly; };
  set readonly(val) { this.#dropdown.readonly = val; };
	
  /**
    */
  validate()
  {
    let ret = true;

    //if set to not allow nulls   
    if (!this.classList.contains('is-hidden') && this.config.required == true && this.value == null)
    {
      ret = false;
      this.markError(true);
    }
    else 
    {
      ret = true;
      this.markSuccess(true);
    }
    return ret;
  };

  cleanupCallback()
  {
    // Clean up dropdown
    if (this.#dropdown) {
      this.#dropdown = null;
    }

    super.cleanupCallback();
  }

};

customElements.define('wd-form-dropdown-grouped',WDFormDropdowngrouped);
